/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCampaigns = /* GraphQL */ `
  query GetCampaigns($account: String, $customer: String) {
    getCampaigns(account: $account, customer: $customer) {
      statusCode
      body
      __typename
    }
  }
`;
export const getConversations = /* GraphQL */ `
  query GetConversations($account: String, $campaign: String) {
    getConversations(account: $account, campaign: $campaign) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCustomers = /* GraphQL */ `
  query GetCustomers($account: String) {
    getCustomers(account: $account) {
      statusCode
      body
      __typename
    }
  }
`;
export const putApproveMessage = /* GraphQL */ `
  query PutApproveMessage($message_id: String, $campaign_id: String) {
    putApproveMessage(message_id: $message_id, campaign_id: $campaign_id) {
      statusCode
      body
      __typename
    }
  }
`;
export const putMessage = /* GraphQL */ `
  query PutMessage($message_id: String, $campaign_id: String, $body: String) {
    putMessage(
      message_id: $message_id
      campaign_id: $campaign_id
      body: $body
    ) {
      statusCode
      body
      __typename
    }
  }
`;
